import { useCallback, useState } from 'react';

export function useArtifactVersionCoTagsExpanded() {
  const [expandedRowKeys, setExpandedRowKeys] = useState<Set<string>>(
    () => new Set()
  );

  const isExpanded = useCallback(
    (rowKey: string) => expandedRowKeys.has(rowKey),
    [expandedRowKeys]
  );

  const toggleExpanded = useCallback((rowKey: string) => {
    setExpandedRowKeys((previous) => {
      const next = new Set(previous);
      if (next.has(rowKey)) {
        next.delete(rowKey);
      } else {
        next.add(rowKey);
      }
      return next;
    });
  }, []);

  return { isExpanded, toggleExpanded };
}
